import {
  FrontSide, BackSide, DoubleSide,
  NearestFilter,
  NearestMipMapNearestFilter,
  NearestMipMapLinearFilter,
  LinearFilter,
  LinearMipMapNearestFilter,
  LinearMipMapLinearFilter,
  RepeatWrapping,
  ClampToEdgeWrapping,
  MirroredRepeatWrapping } from
"three";


/**
 * Controls which face(s) of a polygon are rendered.
 * @enum {number}
 * @alias Autodesk.Viewing.Scene.Side
 */
export const Side = Object.freeze({
  Front: FrontSide,
  Back: BackSide,
  Double: DoubleSide
});

/**
 * Texture minification and magnification filter modes.
 * @enum {number}
 * @alias Autodesk.Viewing.Scene.Filter
 */
export const Filter = Object.freeze({
  Nearest: NearestFilter,
  NearestMipMapNearest: NearestMipMapNearestFilter,
  NearestMipMapLinear: NearestMipMapLinearFilter,
  Linear: LinearFilter,
  LinearMipMapNearest: LinearMipMapNearestFilter,
  LinearMipMapLinear: LinearMipMapLinearFilter
});

/**
 * Texture wrapping modes.
 * @enum {number}
 * @alias Autodesk.Viewing.Scene.Wrapping
 */
export const Wrapping = Object.freeze({
  Repeat: RepeatWrapping,
  ClampToEdge: ClampToEdgeWrapping,
  MirroredRepeat: MirroredRepeatWrapping
});